import React from 'react';

import '../styles/paginator.scss';

function PaginationComponent({ itemsPerPage, totalItems, paginate, currentPage }: any) {
    let totalPages = Math.ceil(totalItems / itemsPerPage)
    const visiblePageCount = 7;

    if (totalPages <= 1) {
        return null;
    }

    const pageNumbers: (number | string)[] = [];

    if (totalPages <= visiblePageCount) {
        for (let i = 1; i <= totalPages; i++) {
            pageNumbers.push(i);
        }
    } else {
        pageNumbers.push(1);

        if (currentPage <= 4) {
            for (let i = 2; i <= 5; i++) {
                pageNumbers.push(i);
            }
            pageNumbers.push('...');
        } else {
            pageNumbers.push('...');

            const firstVisiblePage = currentPage >= totalPages - 3 ? totalPages - 4 : currentPage - 1;
            const lastVisiblePage = currentPage >= totalPages - 3 ? totalPages - 1 : currentPage + 1;

            for (let i = firstVisiblePage; i <= lastVisiblePage; i++) {
                pageNumbers.push(i);
            }

            if (currentPage < totalPages - 3) {
                pageNumbers.push('...');
            }
        }

        pageNumbers.push(totalPages);
    }

    const changePage = (page: number) => paginate(page);

    return (
        <div className='container pagination-container overflow-auto'>
            <nav className="text-center">
                <ul className="pagination pagination-sm">
                    <li className={currentPage === 1 ? "page-item disabled" : "page-item"}>
                        <button type="button" onClick={() => changePage(currentPage - 1)} className="page-link" aria-label="Previous page" disabled={currentPage === 1}>
                            Previous
                        </button>
                    </li>
                    {pageNumbers.map((number, index) => typeof number === 'string' ? (
                        <li key={`ellipsis-${index}`} className="page-item disabled">
                            <span className="page-link">...</span>
                        </li>
                    ) : (
                        <li key={number} className={currentPage === number ? "page-item active" : "page-item"}>
                            <button type="button" onClick={() => changePage(number)} className="page-link" aria-current={currentPage === number ? "page" : undefined}>
                                {number}
                            </button>
                        </li>
                    ))}
                    <li className={currentPage === totalPages ? "page-item disabled" : "page-item"}>
                        <button type="button" onClick={() => changePage(currentPage + 1)} className="page-link" aria-label="Next page" disabled={currentPage === totalPages}>
                            Next
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    );
}

export default PaginationComponent;